'use es6';

import { redirectTo } from 'hub-http/helpers/location';
import * as params from 'hub-http/helpers/params';
import { responseError } from 'hub-http/helpers/response';
import { buildUrl } from 'hub-http/helpers/url';
import { onResponse, resolveApi, hubletApi } from 'hub-http/middlewares/core';
const defaultOptions = {
  method: 'GET',
  withCredentials: true,
  timeout: 7000
};
export const defaults = options => Object.assign({}, defaultOptions, {}, options);

const buildLogoutUrl = options => {
  const hostname = resolveApi(hubletApi('tools', 'hubteam'));
  const loginDescriptor = {
    hostname,
    path: '/login/'
  };
  const redirect = options.location.href;
  loginDescriptor.query = params.stringify({
    redirect
  });
  return buildUrl(loginDescriptor);
};

const handleLogout = response => {
  const {
    options
  } = response;
  const redirectUrl = buildLogoutUrl(options);
  return redirectTo(redirectUrl, options) ? Promise.reject(responseError(response, 'Aborting: redirection in progress')) : response;
};

export const logoutOn = predicate => options => onResponse(response => {
  return predicate(response) ? handleLogout(response) : response;
})(options);
export const logoutOnUnauthorized = logoutOn(response => response.status === 401);